import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  VatAiAcceptance,
  VatAiAcceptancePost,
  VatAiAcceptanceStatus,
} from '../common/VatAiAcceptance';
import { ApiServiceBase } from './ApiServiceBase';

// Backend #579 (slice 3): the BFF's carrier-admin proxy for the signed AI evaluation
// (api/VatAiAcceptance → Catalog.Api). Non-carrier callers get a 403 server-side.
@Injectable({
  providedIn: 'root',
})
export class VatAiAcceptanceService extends ApiServiceBase {
  protected readonly path = 'vataiacceptance';

  // Every record ever signed, newest first — the audit trail behind the current state.
  get(): Observable<VatAiAcceptance[]> {
    return this.http
      .get<VatAiAcceptance[]>(this.getUrl());
  }

  getStatus(): Observable<VatAiAcceptanceStatus> {
    return this.http
      .get<VatAiAcceptanceStatus>(this.getUrl() + '/status');
  }

  // Signs the running model + prompt version. The backend stamps the model and the signer.
  create(acceptance: VatAiAcceptancePost): Observable<VatAiAcceptance> {
    return this.http
      .post<VatAiAcceptance>(this.getUrl(), acceptance);
  }
}
